import {Canvas} from '@react-three/fiber'
import React, {useState} from "react";
import Room from "./Room.jsx";
import Loading from "../../helpers/Loading.jsx";

export default function Visualizer({room, roomData, updateWalls, _handleLoadingError}) {
    const [ loading, setLoading ] = useState(true);

    // Resize canvas
    function resizeCanvasRoot() {
        const canvasRoot = document.querySelector('#root');
        const sourceImg = document.querySelector('#sourceImg');
        const mainContent = document.querySelector('#mainContent');
        const roomActions = document.querySelector('#roomActions');

        if(mainContent !== undefined && mainContent !== null) {
            let vw = mainContent.getBoundingClientRect().width;
            let vh = mainContent.getBoundingClientRect().height;

            //console.log(sourceImg.getBoundingClientRect());
            canvasRoot.setAttribute("style", "width:" + sourceImg.getBoundingClientRect().width + "px; height:" + sourceImg.getBoundingClientRect().height + "px; left:" + (vw - sourceImg.getBoundingClientRect().width) / 2 + "px; top:" + (vh - sourceImg.getBoundingClientRect().height) / 2 + "px;");
            sourceImg.setAttribute("style", "left:" + (vw - sourceImg.getBoundingClientRect().width) / 2 + "px; top:" + (vh - sourceImg.getBoundingClientRect().height) / 2 + "px;");
            roomActions.setAttribute("style", "width:" + sourceImg.getBoundingClientRect().width + "px; height:" + sourceImg.getBoundingClientRect().height + "px; left:" + (vw - sourceImg.getBoundingClientRect().width) / 2 + "px; top:" + (vh - sourceImg.getBoundingClientRect().height) / 2 + "px;");
        }
        setLoading(false);
    }
    document.addEventListener("DOMContentLoaded", () => {
        resizeCanvasRoot();
    });
    window.addEventListener('resize', () => {
        resizeCanvasRoot();
    });

    return <>
        {
            loading && <Loading background="#eeeeee" />
        }
        <img id="sourceImg" src={roomData.canvas.background} alt="" onLoad={resizeCanvasRoot} />
        <div id="root">
            <Canvas
                flat
            >
                {
                    roomData.canvas.mask != "" &&
                    <Room
                        roomData={roomData}
                        isProductOnFloor={room.isProductOnFloor}
                        isProductOnWall={room.isProductOnWall}
                        updateWalls={updateWalls}
                        _handleLoadingError={_handleLoadingError}
                    />
                }
            </Canvas>
        </div>
    </>
}